export default __webpack_public_path__ + "static/media/s6.b777399b.jpg";